import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Booking, CreateOrder, Order, OrderWithConflicts } from '@thro-types/leihbar';
import { ListResponse } from '@thro-types/users';

import { AxiosRequestConfig } from 'axios';
import { useDispatch } from 'react-redux';

import { cancelOrder, createOrder, getOrder, getOrders } from 'api/leihbar';
import { ShoppingCartActions } from 'app/containers/LeihBar/ShoppingCart';

export const useOrdersQuery = (config?: AxiosRequestConfig) => {
  const query = useQuery<ListResponse<Order>, Error>({
    queryKey: ['orders', config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      return getOrders(config);
    },
    placeholderData: keepPreviousData
  });

  return query;
};

export const useOrderQuery = (id: number, config?: AxiosRequestConfig) => {
  const query = useQuery<OrderWithConflicts, Error>({
    queryKey: ['orders', id, config ? JSON.stringify(config.params) : ''],
    queryFn: () => {
      return getOrder(id, config);
    }
  });

  return query;
};

export const useOrderMutation = (config?: AxiosRequestConfig) => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const queryKey = ['orders'];

  const create = useMutation<Order, Error, CreateOrder>({
    mutationFn: async args => {
      return await createOrder(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
      queryClient.invalidateQueries({ queryKey: ['shoppingCart'] });
      dispatch(ShoppingCartActions.setItems([]));
    },
    onError: data => {}
  });

  const cancel = useMutation<Booking[], Error, number>({
    mutationFn: async args => {
      return await cancelOrder(args, config);
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey });
    },
    onError: data => {}
  });

  return { create, cancel } as const;
};
